import script from "./ImageGeneration.vue?vue&type=script&setup=true&lang=js"
export * from "./ImageGeneration.vue?vue&type=script&setup=true&lang=js"

import "./ImageGeneration.vue?vue&type=style&index=0&id=56ecdba2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-56ecdba2"]])

export default __exports__